/* eslint-disable no-plusplus */
/* eslint-disable prettier/prettier */
/* eslint-disable eqeqeq */
import { Button } from '@mui/material';
import React from 'react';

const ShuffleBtn = ({ lastpage, setPage, prevPage, isShuffling, setIsShuffling, theme, setTweet }) => {
    const shuffleArray = (array) => {
        // eslint-disable-next-line no-plusplus
        for (let i = array.length - 1; i > 0; i--) {
            // Generate random number
            const j = Math.floor(Math.random() * (i + 1));

            const temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }

        return array;
    };




    return (
        <Button
            variant="contained"
            // sx={{ mt: 4, backgroundColor: theme.palette.primary.main }}
            sx={{ mt: 4, backgroundColor: theme.palette.primary.main }}
            disabled={isShuffling}
            onClick={() => {
                // condition for 1 page
                if (lastpage < 2) {
                    // return console.log('you have only one page..!')
                    console.log('you have only one page..!');
                    if (setTweet) {
                        console.log('has set tweet',)
                        // setTweet(prev => shuffleArray(prev))
                        // setTweet(prev => {
                        //     const copy = [...prev]
                        //     for (let i = copy.length - 1; i > 0; i--) {
                        //         // Generate random number
                        //         const j = Math.floor(Math.random() * (i + 1));

                        //         const temp = copy[i];
                        //         copy[i] = copy[j];
                        //         copy[j] = temp;
                        //     }
                        //     console.log(copy)

                        //     return prev;
                        // })
                    }
                    return;
                }

                setIsShuffling(true);
                let randomPage = 0;

                // while (randomPage == prevPage.page || randomPage == 0) {
                randomPage = Math.floor(Math.random() * (lastpage - 0) + 0);
                while (randomPage == prevPage.page) {
                    randomPage = Math.floor(Math.random() * (lastpage - 0) + 0);
                }
                console.log(randomPage);

                console.log('final: ', randomPage);
                setPage({ ...prevPage, page: randomPage });
            }}
        >
            {isShuffling ? 'Shuffling....' : 'Shuffle'}
        </Button>
    );
};

export default ShuffleBtn;
